// extracted by mini-css-extract-plugin
export var gradient = "hero-module--gradient--444fb";
export var gradientAnimationText = "hero-module--gradient-animation-text--70711";
export var heroTitle = "hero-module--heroTitle--b16ee";
export var mouse = "hero-module--mouse--11de7";
export var textDes = "hero-module--textDes--2d63c";
export var wheel = "hero-module--wheel--6880d";